import { createFileRoute } from '@tanstack/react-router';
import { HealthDataLoadsScreen } from '../../screens/health/HealthDataLoads';

export const Route = createFileRoute('/health/data-loads')({
  component: HealthDataLoadsScreen,
});
